import React, { useContext, useState, useEffect } from 'react';
import { ThemeContext } from '../../contexts/ThemeContext';
import styled from '@emotion/styled';
import HLSPlayer from './HLSPlayer';
import HLSErrorBoundary from './HLSErrorBoundary';
import { StaticImage } from 'gatsby-plugin-image';

const BackgroundContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: -1;
  pointer-events: none;
`;

const BackgroundElement = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity 0.5s ease-in-out;
  opacity: ${(props) => props.opacity};
  pointer-events: none;
  z-index: ${(props) => props.zIndex || 0};
`;

// onReady - callback function to be called when the video is ready (video is loaded and playing)
const DarkModeBG = ({ onReady }) => {
    const { theme, reducedMotion } = useContext(ThemeContext);
    const [forceRerender, setForceRerender] = useState(0);

    // State variables to control opacity
    const [imageOpacity, setImageOpacity] = useState(reducedMotion ? 1 : 0);
    const [videoOpacity, setVideoOpacity] = useState(reducedMotion ? 0 : 1);

    useEffect(() => {
        // Update opacities when reducedMotion changes
        setImageOpacity(reducedMotion ? 1 : 0);
        setVideoOpacity(reducedMotion ? 0 : 1);
    }, [reducedMotion]);

    useEffect(() => {
        // Force a rerender when the theme changes
        setForceRerender((prev) => prev + 1);
    }, [theme]);

    return (
        <BackgroundContainer>
            {/* Image Element */}
            <BackgroundElement opacity={imageOpacity} zIndex={2}>
                <StaticImage
                    src="../../images/still.png"
                    alt=""
                    layout="fullWidth"
                    objectFit="cover"
                    style={{
                        width: '100vw',
                        height: '100vh',
                        filter:
                            theme === 'light'
                                ? 'invert(1) hue-rotate(180deg) brightness(96%)'
                                : 'none',
                        transition: 'filter 0.2s ease-in-out',
                    }}
                />
            </BackgroundElement>

            {/* Video Element */}
            <BackgroundElement opacity={videoOpacity} zIndex={1}>
                <HLSErrorBoundary>
                    <HLSPlayer theme={theme} onVideoReady={onReady} />
                </HLSErrorBoundary>
            </BackgroundElement>
        </BackgroundContainer>
    );
};

export default DarkModeBG;
